import { render } from "./TravelPassYoungAdultDetails.vue?vue&type=template&id=3916a45a&scoped=true&lang=pug"
import script from "./TravelPassYoungAdultDetails.vue?vue&type=script&lang=ts"
export * from "./TravelPassYoungAdultDetails.vue?vue&type=script&lang=ts"

import "./TravelPassYoungAdultDetails.vue?vue&type=style&index=0&id=3916a45a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3916a45a"

export default script